import request from "@/utils/request";

export function getImageUrl(imagePath) {
  return request({
    url: "/common/images/" + imagePath,
    method: "get",
  });
}

const BASE_A = process.env.VUE_APP_BASE_API || "";

export default {
  getImageUrl,
  BASE_A,
};
